import React from 'react';
import styled from 'styled-components';

export default function CloseButton({ onClose }) {
  return (
    <Button aria-label='Close' onClick={onClose}>
      <img src='/icons/x-icon-product.svg' alt='Close Icon' height={21} width={21} />
    </Button>
  );
}

const Button = styled.div`
  width: 50px;
  position: absolute;
  right: -24px;
  top: -24px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;

  img {
    height: 21px;
  }
`;
